import * as React from "react";
import   { useState } from 'react';
import styled from "styled-components";
import { Tooltip, Modal ,Input} from 'antd';
import { useAuth } from "@/component/Auth";
import { LOGININFOSTORE, LOGINTOKEN, APKNAME, RECORD_SERVER } from "@/config/const";
import Alink from "@/component/Alink";
import { usePage } from "@/component/PageControl";
import { SettingOutlined ,NotificationOutlined} from "@ant-design/icons";
import { Badge, message } from "antd";
import useRtm from "@/hooks/use-rtm";
import { useLocation, useHistory } from "react-router-dom";
import prompt from "antd-prompt";
import { users } from "@/api";
import isElectron from "is-electron";
import { storage } from "@/util";
import * as consts from "@/config/const";
import logo from "../assets/images/logo.svg";
import login from "../assets/images/login.svg";
import meetingIcon from "../assets/images/monitor-recorder.svg";
import meetingFastIcon from "../assets/images/monitor-fast.svg";
import meetingCalendarIcon from "../assets/images/monitor-calendar.png";
import clockIcon from "../assets/images/clock-1.svg";
import avatarImage from "../assets/images/avatar-image.png";
export const MainContent = styled.div`
  flex: 1;
  display: flex;
`;

const LeftContainer = styled.div`
  width: 240px;
  height: 100%;
  background: #eee;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background: white;
  border-radius: 16px 0px 0px 16px;
  .logo {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 30px;
    padding-bottom: 50px;
  }
  .list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .userinfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    .avatar {
      width: 90px;
      height: 90px;
      overflow: hidden;
      border-radius: 45px;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 22px;
      font-weight: bold;
    }
    .username {
      margin-top: 10px;
      font-size: 14px;
    }
  }
  .alink {
    padding: 6px;
  }
  .bottom {
    position: absolute;
    width: 200px;
    bottom: 20px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }
  .icon {
    padding-right: 5px;
  }
`;

const ___navlinks = [
  { to: "/", txt: "Уулзалтад орох", icon: <img className="icon" src={meetingIcon} alt="meetingIcon" /> },
  { to: "/main/quick", txt: "Уулзалт үүсгэх", icon: <img className="icon" src={meetingFastIcon} alt="meetingIcon" /> },
  // { to: "/main/appointment", txt: "Уулзалт захиалах", icon: <img className="icon" src={meetingCalendarIcon} alt="meetingCalendarIcon" /> },
  // { to: "/main/history", txt: "Уулзалтын түүх", icon: <img className="icon" src={clockIcon} alt="clockIcon" /> },
];
 
 
const MainLeftMenu: React.FunctionComponent = () => {
  const rtm = useRtm({}, (closedByServer)=>{
    console.log("[Login] closedByServer", closedByServer);
    // //关闭rtm
    // rtm.logout();
    // //退出登录
    // storage.remove(LOGININFOSTORE);
    // storage.remove(LOGINTOKEN);
    // if (isElectron()) {
    //   alert(`推出登陆!`);
    //   history.replace("/");
    // } else {
    //   window.location.href = "/";
    // }
    // alert("检测到相同账号重复登录，已自动退出!");
  });
 
  const [open, setOpen] = useState(false);
  const [webLinkStatus, setWebLinkStatus] = useState(true)

  const [mvalue, setMvalue] = useState('');
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState('Content of the modal');
  const auth = useAuth();
  const location = useLocation();
  const history = useHistory();
  const { loggedIn, loginfo, updateLogInfo } = auth;

  const page = usePage();
  const { goSetting, currentLink } = page;
  const messageEve = (evt: any) => {
    //
    console.log("Disconnect message",evt);
  };
  const Avatar = () =>
    loggedIn && loginfo.avatar ? (
      <img className="avatar" src={loginfo.avatar} alt={loginfo.virtualNum} />
    ) : (
      <img className="avatar" src={avatarImage} alt="avatarImage" />
    );
    const exitlogin = () => {
      storage.remove(LOGININFOSTORE);
      storage.remove(LOGINTOKEN);
      if (isElectron()) {
        alert(`Нэвтрэх хуудас руу чиглүүлж байна`);
        history.replace("/");
      } else {
        window.location.href = "/";
      }
    };
  // const Avatar = () =>
  //     <img className="avatar" src={suhang} alt="" />;

  React.useEffect(() => {
    if (!loggedIn) {
      const { pathname } = location;
      if (
        !/reg|login|join|losepass/.test(pathname) || pathname !== "/"
      ) {
        console.log("auto login FAIL")
        history.replace("/");
      } else {
        console.log("auto login success")
        const isAutoLogin = localStorage.getItem('autoLogin');
        console.log("is  autoLogin???:"+isAutoLogin)
        if(!isAutoLogin){
          console.log("not  isAutoLogin !!!!!!!!!! exitlogin")
          exitlogin()
        }
      }
    }
  }, [loggedIn]);
  React.useEffect(() => {
    if (rtm) {
   
      rtm.addEventListener("message", messageEve);
    }

    return () => {
      if (rtm) {
        
        rtm.removeEventListener("message", messageEve);
      }
    };
  }, [rtm]);
  React.useEffect(()=>{
    const checkStorage = () => {
      // 检查storage变化的逻辑
      setWebLinkStatus(storage.get( consts.WebLinkStatus))
       
      //console.log("WebLinkStatus::",webLinkStatus)
    };
     

    const intervalId = setInterval(checkStorage, 3000); // 每3秒检查一次

    return () => {
        clearInterval(intervalId);
    };
  },[ ])
  React.useEffect(() => {
    const info = storage.get(LOGININFOSTORE);
    if (info.userId) {
      auth.updateLogInfo(info);
    }
  }, []);

  const updateName = async (nickname: string) => {
    const { avatar: headimage, email, enterpriseName: department } = loginfo;
    await users.userinfoupdate({ nickname, headimage, email, department });
    updateLogInfo({ realName: nickname });
    message.success("Амжилттай өөрчлөгдлөө");
  };
  const nameClickHandler = async () => {
    if (!loggedIn) return;

    try {
      const name = await prompt({
        title: "Шинэ нэр оруулна уу",
        value: loginfo.realName,
        placeholder: "Шинэ нэр оруулна уу",
        rules: [
          {
            required: true,
            message: "Шинэ нэр оруулна уу",
          },
        ],
        modalProps: {
          width: "400px",
        },
      });
      updateName(name);
    } catch (e) {
      console.log("Please enter name");
    }
  };
  const showModal=()=>{
    setOpen(true);
  }
  const handleOk = () => {
    setConfirmLoading(true);
    // 这里添加你的确认操作代码
    setConfirmLoading(false);
    setOpen(false);
  };
  
  const handleCancel = () => {
    setOpen(false);
  };
 
 
  return (
    <LeftContainer>
      <div className="logo">
        <img style={{ width: "110px" }} src={logo} alt="Logo" />
      </div>
      <div className="userinfo">
        <Avatar />
        <div
          className={`username ${loginfo.realName ? "pointer" : ""}`}
          onClick={nameClickHandler}
        >
          {loginfo.realName || "Username"}
        </div>
      </div>
      <div className="list">
      {!loggedIn && (
        <>
          <Alink
            className="alink"
            to="/login"
            active={currentLink === "/login"}
            disabled={false}
          >
            <img className="icon" src={login} alt="login" />
            Нэвтрэх
          </Alink>
          <Alink
            className="alink"
            to="/"
            active={currentLink === "/"}
            disabled={false}
          >
            <img className="icon" src={meetingIcon} alt="meetingIcon" />
            Уулзалтад орох
          </Alink>
        </>
      )}
      {loggedIn &&
        ___navlinks.map((t) => (
          <Alink
            className="alink"
            key={t.to}
            to={t.to}
            disabled={!loggedIn}
            active={currentLink === t.to}
          >
            {t.icon}
            {t.txt}
          </Alink>
        ))}
      </div>
      <div className="bottom">
        <div className="status pr10">
          <Badge status="success" />
          { webLinkStatus ? <span>Сервер холбогдсон </span> : <span>Сервер унтарсан </span>}
        </div>
        {/* <SettingOutlined onClick={goSetting} /> */}
      </div>
    </LeftContainer>
  );
};

export default MainLeftMenu;
